<template>
    <api-post-button
        :classes="btnClass"
        confirm="Are you sure you want to send a reminder to this participant?"
        :disabled="disabled"
        :endPoint="`/api/v0/participants/${participant.id}/prepay/invite`"
        @error="reminderCouldntSend"
        :icon-class="iconClass"
        method="post"
        :params="{
            email: participant.email,
            first_name: participant.first_name,
            last_name: participant.last_name,
            message,
        }"
        @response="reminderSent"
        tag="button"
        :text="btnText"
    ></api-post-button>
</template>

<script>
import ApiPostButton from "../../../Utility/Buttons/ApiPostButton.vue";

export default {
    name: 'PrepaySendReminderButton',

    components: {
        ApiPostButton,
    },

    props: {
        participant: {
            required: true,
            type: Object,
            validator(participant) {
                return Object.hasOwnProperty.call(participant, 'email')
                    && Object.hasOwnProperty.call(participant, 'first_name')
                    && Object.hasOwnProperty.call(participant, 'id')
                    && Object.hasOwnProperty.call(participant, 'last_name')
            },
        },
    },

    data() {
        return {
            btnClass: 'btn btn-xs btn-warning',
            btnText: 'Remind',
            disabled: false,
            iconClass: 'fa fa-bullhorn',
            message: '',
            reminderSuccess: null,
        }
    },

    methods: {
        reminderCouldntSend() {
            Object.assign(this, {
                btnClass: 'btn btn-xs btn-danger',
                btnText: `Couldn't send`,
                disabled: false,
                iconClass: 'fa fa-ban',
                reminderSuccess: false,
            });
        },
        reminderSent() {
            Object.assign(this, {
                btnClass: 'btn btn-xs btn-success',
                btnText: 'Reminder sent',
                disabled: true,
                iconClass: 'fa fa-check',
                reminderSuccess: true,
            });
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Participants/Utilities/Buttons/SendPrepayReminderButton.vue